import {
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastNoAnimation, ToastPackage, ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'bw-toastr-component',
  templateUrl: './custom-toasts.component.html',
  styleUrls: ['./custom-toasts.component.scss'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'animate.enter': 'fadeIn',
    '[class.fadeOut]': 'isLeaving()',
    '(animationend)': 'onAnimationEnd()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class CustomToastsComponent extends ToastNoAnimation {
  declare protected toastrService: ToastrService;
  declare toastPackage: ToastPackage;
  private readonly router = inject(Router);
  readonly isLeaving = signal<boolean>(false);

  constructor() {
    const toastrService = inject(ToastrService);
    const toastPackage = inject(ToastPackage);
    const appRef = inject(ApplicationRef);

    super(toastrService, toastPackage, appRef);
    this.toastrService = toastrService;
    this.toastPackage = toastPackage;
  }

  navigateTo(url: string, id: string | number): void {
    if (!this.router.url.startsWith(`${url}${id}`)) {
      this.router.navigate([`${url}${id}`]);
    }
    this.remove();
  }

  override remove(): void {
    if (this.isLeaving()) return;
    this.isLeaving.set(true);
  }

  onAnimationEnd(): void {
    if (this.isLeaving()) {
      super.remove(); // REQUIRED: lets ngx-toastr clean up properly
    }
  }
}
